// extracted by mini-css-extract-plugin
export default {"component":"EnumeratedInput_component__5lCMs","input":"EnumeratedInput_input__GZXR4"};